import React, { useState, useEffect, useRef } from 'react';
import { KTSVG } from '../../../../../_mexablock/helpers';
import { useFormik } from 'formik';
import {
  getToday,
  getYesterday,
  getThisWeek,
  getLast15Days,
  getThisMonth,
  getLastMonth,
  formatDateMonthGuinMedio,
} from '../../../../../_mexablock/helpers';

type Props = {
  initFilterValues: any;
  onCleanFilter: () => void;
  onSearchFilter: (values: any) => void;
};

const Filter: React.FC<Props> = ({
  initFilterValues,
  onSearchFilter,
  onCleanFilter,
}) => {
  const [filterValues, setFilterValues] = useState(initFilterValues);
  const dateInputRef = useRef<HTMLInputElement | null>(null);
  const [showCalendar, setshowCalendar] = useState<boolean>(false);

  useEffect(() => {
    if (initFilterValues) {
      setFilterValues(initFilterValues);
    }
  }, [initFilterValues]);

  const formFilter = useFormik({
    initialValues: filterValues,
    enableReinitialize: true,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      onSearchFilter(values);
    },
  });

  useEffect(() => {
    if (dateInputRef.current) {
      const input = dateInputRef.current as HTMLInputElement;
      input.style.setProperty('overflow', 'hidden');
      input.style.setProperty('position', 'relative');

      setTimeout(() => {
        try {
          const shadowRoot = (input as any).shadowRoot;
          if (shadowRoot) {
            const clearButton = shadowRoot.querySelector(
              '::-webkit-clear-button'
            ) as HTMLElement;
            if (clearButton) {
              clearButton.style.display = 'none';
            }
          }
        } catch (error) {
          console.warn('No se pudo acceder al Shadow DOM:', error);
        }
      }, 100);
    }
  }, []);

  return (
    <>
      <div className="card-title align-items-start flex-column">
        <a
          href="#/"
          className={
            formFilter.values.nombre !== ''
              ? 'btn btn-sm btn-primary'
              : 'btn btn-sm btn-light-primary'
          }
          data-kt-menu-trigger="click"
          data-kt-menu-placement="left-start"
          data-kt-menu-flip="top-end"
        >
          Fecha
          <KTSVG
            path="/media/icons/duotune/general/gen014.svg"
            className="svg-icon-5 svg-icon-gray-500 ms-2"
          />
        </a>
        <div
          className="menu menu-sub menu-sub-dropdown w-250px w-md-400px"
          data-kt-menu="true"
          style={{
            maxHeight: 'calc(100vh - 100px)',
            overflow: 'visible',
            position: 'absolute',
            inset: 'auto auto auto auto',
          }}
        >
          <div className="px-7 py-5">
            <div className="fs-5 text-dark fw-bolder">Opciones de filtro</div>
          </div>

          <div className="separator border-gray-200"></div>
          <form
            id="kt_modal_generic_form"
            className="form"
            action="#"
            onSubmit={formFilter.handleSubmit}
          >
            <div className="px-7 py-5">
              <div className="mb-5">
                <button
                  className="btn btn-sm btn-light-primary w-100"
                  type="button"
                  onClick={() => {
                    const { start } = getToday();
                    formFilter.setFieldValue(
                      'init_date',
                      formatDateMonthGuinMedio(start.toISOString())
                    );
                    formFilter.setFieldValue('end_date', '');
                    setshowCalendar(false);
                  }}
                >
                  Hoy
                </button>
              </div>
              <div className="mb-5">
                <button
                  type="button"
                  className="btn btn-sm btn-light-primary w-100"
                  onClick={() => {
                    setshowCalendar(false);
                    const { start, end } = getYesterday();
                    formFilter.setFieldValue(
                      'init_date',
                      formatDateMonthGuinMedio(start.toISOString())
                    );
                    formFilter.setFieldValue(
                      'end_date',
                      formatDateMonthGuinMedio(end.toISOString())
                    );
                  }}
                >
                  Ayer
                </button>
              </div>
              <div className="mb-5">
                <button
                  type="button"
                  className="btn btn-sm btn-light-primary w-100"
                  onClick={() => {
                    setshowCalendar(false);
                    const { start, end } = getThisWeek();
                    formFilter.setFieldValue(
                      'init_date',
                      formatDateMonthGuinMedio(start.toISOString())
                    );
                    formFilter.setFieldValue(
                      'end_date',
                      formatDateMonthGuinMedio(end.toISOString())
                    );
                  }}
                >
                  Esta semana
                </button>
              </div>
              <div className="mb-5">
                <button
                  type="button"
                  className="btn btn-sm btn-light-primary w-100"
                  onClick={() => {
                    setshowCalendar(false);
                    const { start, end } = getLast15Days();
                    formFilter.setFieldValue(
                      'init_date',
                      formatDateMonthGuinMedio(start.toISOString())
                    );
                    formFilter.setFieldValue(
                      'end_date',
                      formatDateMonthGuinMedio(end.toISOString())
                    );
                  }}
                >
                  Últimos 15 dias
                </button>
              </div>
              <div className="mb-5">
                <button
                  type="button"
                  className="btn btn-sm btn-light-primary w-100"
                  onClick={() => {
                    setshowCalendar(false);
                    const { start, end } = getThisMonth();
                    formFilter.setFieldValue(
                      'init_date',
                      formatDateMonthGuinMedio(start.toISOString())
                    );
                    formFilter.setFieldValue(
                      'end_date',
                      formatDateMonthGuinMedio(end.toISOString())
                    );
                  }}
                >
                  Este mes
                </button>
              </div>
              <div className="mb-5">
                <button
                  type="button"
                  className="btn btn-sm btn-light-primary w-100"
                  onClick={() => {
                    setshowCalendar(false);
                    const { start, end } = getLastMonth();
                    formFilter.setFieldValue(
                      'init_date',
                      formatDateMonthGuinMedio(start.toISOString())
                    );
                    formFilter.setFieldValue(
                      'end_date',
                      formatDateMonthGuinMedio(end.toISOString())
                    );
                  }}
                >
                  Mes pasado
                </button>
              </div>
              <div className="mb-5">
                <button
                  type="button"
                  className="btn btn-sm btn-light-primary w-100"
                  onClick={() => setshowCalendar(true)}
                >
                  Rango de fechas
                </button>
              </div>
              {showCalendar ? (
                <div className="row">
                  <div className="mb-5 col-6">
                    <label className="form-label fw-bold">Fecha inicial:</label>
                    <input
                      type="date"
                      className="form-control"
                      ref={dateInputRef}
                      value={formFilter.values.init_date || ''}
                      onInput={(e) => {
                        const target = e.target as HTMLInputElement;
                        if (target.value === '') {
                          formFilter.setFieldValue('init_date', '');
                        }
                      }}
                      onChange={(e) => {
                        if (e.target.value) {
                          const fecha = new Date(e.target.value)
                            .toISOString()
                            .split('T')[0];
                          formFilter.setFieldValue('init_date', fecha);
                        }
                      }}
                      autoComplete="off"
                    ></input>
                  </div>
                  <div className="mb-5 col-6">
                    <label className="form-label fw-bold">Fecha fin:</label>
                    <input
                      type="date"
                      className="form-control"
                      onKeyDown={(e) => e.preventDefault()}
                      value={formFilter.values.end_date || ''}
                      onInput={(e) => {
                        const target = e.target as HTMLInputElement;
                        if (target.value === '') {
                          formFilter.setFieldValue('end_date', '');
                        }
                      }}
                      onChange={(e) => {
                        if (e.target.value) {
                          const fecha = new Date(e.target.value)
                            .toISOString()
                            .split('T')[0];
                          formFilter.setFieldValue('end_date', fecha);
                        }
                      }}
                      autoComplete="off"
                    ></input>
                  </div>
                </div>
              ) : null}

              <div className="d-flex justify-content-end">
                <button
                  type="reset"
                  className="btn btn-sm btn-white btn-active-light-primary me-2"
                  data-kt-menu-dismiss="true"
                  onClick={() => {
                    formFilter.resetForm();
                    onCleanFilter();
                  }}
                >
                  Limpiar
                </button>

                <button
                  type="submit"
                  className="btn btn-sm btn-primary"
                  data-kt-menu-dismiss="true"
                >
                  Buscar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export { Filter };
